<template>
  <section class="" :aria-label="ariaLabel">
  <div class="container-fluid podcast-container">
    <div class="row podcast-row">
      <div class="col-12 col-md-6 col-xl-5 left-column">
        <div class="podcast--desc">
          <h2 class=''>{{ podcastSectionTitle }}</h2>
          <div class='podcast-intro col-6 col-md-12'>{{ podcastSectionDesc }}</div>
        </div>
        <div class="podcast--desc-bottom">
          <h3 class='sub-title mt-3'>{{ podcastSectionSubTitle }}</h3>
          <div class='sub-desc' v-html="podcastSectionSubDesc"></div>
        </div>
      </div>
      <div class="col-12  col-xl-4 offset-xl-3">
        <h3 class=''>{{ podcastTitle }}</h3>
        <div class="" v-html="podcast"></div>
      </div>
    </div>
  </div>
  </section>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  data() {
    return {
    };
  },
})
class ExperiencePodcast extends Vue {
    @Prop({ type: String })
      podcastSectionTitle;

    @Prop({ type: String })
      podcastSectionDesc;

    @Prop({ type: String })
      podcastSectionSubTitle;

    @Prop({ type: String })
      podcastSectionSubDesc;

    @Prop({ type: String })
      podcastTitle;

    @Prop({ type: String })
      podcast;

    @Prop({
      type: String,
      required: true,
    })
    ariaLabel;
}

export default ExperiencePodcast;
</script>

<style lang="scss" scoped>
.podcast-container {
  padding: 25px;
  text-align: left;
}

.podcast-intro {
 font-size: 24px;
 padding: 0;
}

.podcast--desc {
  background-image: url('/images/experiences/CivilRights/cr-fist.svg');
  background-position: -10px bottom;
  background-repeat: no-repeat;
  background-size: 160%;
  padding-bottom: 30px;
}

/* Landscape */
@media only screen and (min-width: 567px) and (min-height: 319px)  {
  .podcast--desc {
    background-clip: content-box;
    background-position: 40vw 0;
    background-size: 80%;
  }
}

/* iPad */
@media only screen and (min-width: 768px)  {
  .podcast--desc { background-image: none; }
  .podcast--desc-bottom { background-color: white; }

  .podcast-row {
    background-image: url('/images/experiences/CivilRights/cr-fist.svg');
    background-position: 110px 160px;
    background-repeat: no-repeat;
    background-size: 129%;
    background-clip: content-box;
  }
}

@media only screen and (min-width: 1024px)  {
  .podcast-container { padding: 75px; }
  .podcast-row {
      background-position: 110px top;
  }
  .left-column { padding-right: 50px; }
}

@media only screen and (min-width: 1200px)  {
  .podcast-row {
    background-position: center bottom;
    background-size: 60%;}
}

@media only screen and (min-width: 1366px)  {
  .podcast-row { background-size: 80%; }
}

@media only screen and (min-width: 1680px)  {
  .podcast-row {
    background-size: 60%;}
}

@media only screen and (min-width: 1790px)  {
  .podcast-row {
    background-size: 50%;}
}

</style>
